<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div id="fixed-div-cheftaine">
    <div id="cheftaine-petit-div" @click="openTooltip()">
      <img
        id="cheftaine-petit"
        src="https://cdn.exploreve.fr/content/adaptation_petits/cheftaine_petits.svg"
        alt="daria"
      />
      <BTooltip
        ref="tooltip"
        :show.sync="show"
        variant="light"
        triggers="manual"
        placement="lefttop"
        target="fixed-div-cheftaine"
      >
        <div>
          <vue-markdown :source="text" class="text-aide-petit content text-left"></vue-markdown>

          <!-- <p class="text-aide-petit">{{ text }}</p> -->
        </div>
      </BTooltip>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.content {
  font-family: "Faune", Avenir, Helvetica, Arial, sans-serif;
  font-weight: normal;
}
.text-aide-petit {
  font-family: "Faune";
  font-weight: normal;
  text-align: center;
  color: #2c3e50;
  font-size: 1rem;
}
#cheftaine-petit {
  height: 100%;
}
#fixed-div-cheftaine {
  position: fixed;
  bottom: 0px;
  right: 0;
  margin: 30px;
  height: 120px;
  width: 120px;
}
#cheftaine-petit-div {
  position: fixed;
  bottom: 0px;
  right: 0;
  margin: 30px;
  padding: 10px;
  height: 100px;
  width: 100px;
  cursor: pointer;

  transition: transform 0.1s ease-in-out;
  &:hover {
    transform: scale(1.2);
  }
}
</style>
<script>
import ApiService from "@/services/ApiService";
import VueMarkdown from "vue-markdown";

export default {
  data: function () {
    return {
      showCheftaine: true,
      show: false,
      text: "",
      i: 0
    };
  },
  components: {
    "vue-markdown": VueMarkdown
  },
  methods: {
    openTooltip() {
      this.fetchHints();
      this.show = !this.show;
    },
    fetchHints: async function () {
      let path = this.$route.path;
      let id = path.split("/");
      let resp;
      if (id.length < 3) {
        resp = await ApiService.get(`/hints/${id[1].slice(id[1].length - 1)}/0`);
      } else {
        resp = await ApiService.get(`/hints/${id[1].slice(id[1].length - 1)}/${id[2]}`);
      }
      if (resp.data.hints.length > 0) {
        if (this.i >= resp.data.hints.length) {
          this.i = 0;
        }
        this.text = resp.data.hints[this.i].content;
        this.i++;
      } else {
        this.text = "Je ne peux pas t'aider pour le moment, désolé.";
      }
    }
  }
};
</script>
